import { QueryClient } from '@tanstack/react-query';
import { ApiError, NetworkError } from '@/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: (count, e) => {
        // Never retry policy/validation outcomes; retry transient failures twice.
        if (e instanceof ApiError && e.status < 500 && e.status !== 429) return false;
        if (e instanceof NetworkError) return count < 1;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
